import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

// export class returnMessage{
//   message: string;
//   constructor(message: string) {
//       this.message = message;
//   }
// }

export class User {
  name: string;
  username: string;
  serverlocation: string;
  userid: string;
  token: string;
  hotelname: string;
  isposthotel: string;
  use_timer_schedule: number;
  icno: string;
  db_hotel: string;
  db_pos: string;
  db_inv: string;
  list_property: string[];

  constructor(name: string, username: string, serverlocation: string, userid: string, token: string, hotelname: string, isposthotel: string, use_timer_schedule: number, icno: string, db_pos: string, db_hotel:string, db_inv: string, list_property: string[]) {
      this.name = name;
      this.username = username;
      this.serverlocation = serverlocation;
      this.userid = userid;
      this.token = token;
      this.hotelname = hotelname;
      this.isposthotel = isposthotel;
      this.use_timer_schedule = use_timer_schedule;
      this.icno = icno;
      this.db_hotel = db_hotel;
      this.db_inv = db_inv;
      this.db_pos = db_pos;
      this.list_property = list_property;
  }
}

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile'
  })
};

@Injectable()
export class AuthProvider {
  currentUser: User;
  // currentMessage: returnMessage;

  constructor(public http: HttpClient) {
      console.log('Hello AuthProvider Provider');
  }


  public login(credentials) {

  //   var body = JSON.stringify({
  //     "username": credentials.username,
  //     "password": credentials.password
  // });

  // let headers = new HttpHeaders();
  //         headers.append('Content-Type', 'application/json');
  //         headers.append("Client-Service", "insoft-client");
  //         headers.append("Auth-Key", "insoftmobile");
  // //console.log('Username ' + credentials.username);
  // return new Promise((resolve, reject) => {
  //   // this.http.set
  //   // this.http.setServerTrustMode('nocheck', function () {
  //   //     console.log('success!');
  //   // }, function () {
  //   //     console.log('error :(');
  //   // });
  //   this.http.post('http://'+credentials.serverlocation+'/iservice/auth/login', body, {
  //       headers: new HttpHeaders({
  //         'Content-Type':'application/json',
  //         'Client-Service':'insoft-client',
  //         'Auth-Key':'insoftmobile'}),
  //     })
  //     .subscribe(res => {

  //       resolve(res);
  //       if(res['status'] == 200) {
  //         this.currentUser = new User(credentials.username, credentials.username, credentials.serverlocation, res['id'], res['token'], res['hotelname'], res['isposthotel']);
  //         this.currentMessage = new returnMessage(res['message'] + ': '+'http://' + credentials.serverlocation + '/iservice/auth/login');

  //       } else {
  //         this.currentMessage = new returnMessage(res['message']);
  //       }
  //       //console.log(res.message);
  //     }, (err) => {
  //       reject(err);
  //       this.currentMessage = new returnMessage("No response from server.");
  //       //console.log(err);
  //     });
  // });


  //   //ORI HERE ====================================
      if (credentials.username === null || credentials.password === null) {
          return Observable.throw("Please insert credentials");
      } else {
          return Observable.create(observer => {

              // At this point make a request to your backend to make a real check!
              var body = JSON.stringify({
                  "username": credentials.username,
                  "password": credentials.password
              });

              let headers = new Headers();
              headers.append('Content-Type', 'application/json');
              headers.append("client-service", "insoft-client");
              headers.append("auth-key", "insoftmobile");
              headers.append("apptype", "17")   //17 = iDashboard, from iTeam > Products;

              this.http.post<any>(credentials.serverlocation + '/auth/loginds', body, httpOptions)
                  .subscribe(data => {
                      if(data == null) {
                          observer.next(false);
                          observer.complete();
                      } else {
                          if (data.status == 200) {
                              this.currentUser = new User(credentials.username, credentials.username, credentials.serverlocation, data.id, data.token, data.hotelname, data.isposthotel, data.use_timer_schedule, '','','','', data.list_property);
                              observer.next(true);
                              observer.complete();
                          } else {
                              observer.next(false);
                              observer.complete();
                          };
                      }


                  }, error => {
                      console.log("Oooops!");
                      observer.next(false);
                      observer.complete();
                  });

          });
      }
      // END ORI ======================================
  }
//   public getReturnMessage(): returnMessage {
//     return this.currentMessage;
// }
  public getUserInfo(): User {
      return this.currentUser;
  }

  public getUserDetailByICNO(serverlocation) {
    let info = this.getUserInfo();

    return Observable.create(observer => {

        // At this point make a request to your backend to make a real check!

        var body = JSON.stringify({
            "icno": info.icno,
            "userid": info.userid
        });

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append("client-service", "insoft-client");
        headers.append("auth-key", "insoftmobile");
        headers.append("apptype", "17")   //17 = iDashboard, from iTeam > Products;

        this.http.post<any>(serverlocation + '/authds/getuserdetailbyicno', body, httpOptions)
            .subscribe(data => {
                if(data == null) {
                    observer.next(false);
                    observer.complete();
                } else {
                    if (data.status == 200) {
                        this.currentUser.db_hotel = data.db_hotel;
                        this.currentUser.db_pos = data.db_pos;
                        this.currentUser.db_inv = data.db_inv;
                        // this.currentUser.hotelname = data.hotelname;
                        // this.currentUser.isposthotel = data.isposthotel;
                        // this.currentUser.use_timer_schedule = data.use_timer_schedule;

                        observer.next(true);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    };
                }


            }, error => {
                console.log("Oooops!");
                observer.next(false);
                observer.complete();
            });

    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts